import React__default from 'react';

const getNextIndexFromKey = (key, length, index, direction = 'vertical') => {
  const previousKey = direction === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
  const nextKey = direction === 'horizontal' ? 'ArrowRight' : 'ArrowDown';

  switch (key) {
    case previousKey:
      return index !== undefined ? index - 1 < 0 ? 0 : index - 1 : index;

    case nextKey:
      return index !== undefined ? index + 1 >= length ? index : index + 1 : index;

    case 'Home':
      return 0;

    case 'End':
      return length - 1;

    default:
      return;
  }
};
const useListKeyboardNavigation = (length = 0, options = {
  direction: 'vertical'
}) => {
  const [index, setIndex] = React__default.useState(options.initialIndex);

  const getNextIndex = event => {
    const nextIndex = getNextIndexFromKey(event.key, length, index, options.direction);

    if (nextIndex !== undefined) {
      event.preventDefault();
    }

    return nextIndex;
  };

  return [index, setIndex, getNextIndex];
};

export { getNextIndexFromKey, useListKeyboardNavigation };
//# sourceMappingURL=useListKeyboardNavigation.js.map
